import { inject, Injectable } from "@angular/core";
import { CdrService as CmsApiCdrService } from '../../../core/cms-api/services/cdr.service'
import { CdrFilter, CdrRequest } from "../models/cdr.model";
import { Observable } from "rxjs";
import { CdrFilterParametersResult, CdrItemCdrSummaryResponsePagedResponseWithMetadataResult } from "../../../core/cms-api/models";
import { StrictHttpResponse } from "../../../core/cms-api/strict-http-response";

@Injectable({
    providedIn: 'root',
})
export class CdrService {
    private apiCdrService = inject(CmsApiCdrService);
    searchCdrService(request: CdrRequest, filter: CdrFilter, pageSize: number, pageIndex: number): Observable<CdrItemCdrSummaryResponsePagedResponseWithMetadataResult> {
        return this.apiCdrService.cdrSearchPost({
            body: {
                operatorId: request.operatorId,
                userTokenId: request.userTokenId,
                dateFrom: request.dateFrom,
                dateTo: request.dateTo,
                pageIndex: pageIndex,
                pageSize: pageSize,
                chargerIds: filter?.chargerId,
                chargerSerialNumbers: filter?.chargerSerialNumber,
                chargingAmountRange: filter?.chargingAmount?.map(x => x * 1000),
                chargingGroups: filter?.chargerGroups,
                chargingLocations: filter?.chargingLocation,
                chargingTimeRangeInMinutes: filter?.chargingTime,
                cities: filter?.cities,
                countries: filter?.countries,
                plZs: filter?.plz,
                streets: filter?.street,
                connectors: filter?.connectors,
                chargingStationTypes: filter?.chargingStationTypes,
                chargerVendors: filter?.chargerVendors
            }
        });
    }

    loadCdrFilterParameters(request: CdrRequest): Observable<CdrFilterParametersResult> {
        return this.apiCdrService.cdrGetFilterParametersPost({
            body: {
                operatorId: request.operatorId,
                userTokenId: request.userTokenId,
                dateFrom: request.dateFrom,
                dateTo: request.dateTo
            }
        });
    }

    exportCdrsToCsv(
        request: CdrRequest, filter: CdrFilter, pageSize: number, pageIndex: number
    ): Observable<StrictHttpResponse<Blob>> {
        return this.apiCdrService.cdrDownloadCsvPost$Response(
            {
                body: {
                    operatorId: request.operatorId,
                    userTokenId: request.userTokenId,
                    dateFrom: request.dateFrom,
                    dateTo: request.dateTo,
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    chargerIds: filter?.chargerId,
                    chargerSerialNumbers: filter?.chargerSerialNumber,
                    chargingAmountRange: filter?.chargingAmount?.map(x => x * 1000),
                    chargingGroups: filter?.chargerGroups,
                    chargingLocations: filter?.chargingLocation,
                    chargingTimeRangeInMinutes: filter?.chargingTime,
                    cities: filter?.cities,
                    countries: filter?.countries,
                    plZs: filter?.plz,
                    streets: filter?.street,
                    connectors: filter?.connectors,
                    chargingStationTypes: filter?.chargingStationTypes,
                    chargerVendors: filter?.chargerVendors
                }
            }
        )
    }
}